define('home/templates/loadError',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"empty-message\">\n<img src=\""
    + alias2(helpers.urlfor.call(alias1,"cdn",{"name":"urlfor","hash":{},"data":data}))
    + "/img/Pam_Error.png\" class=\"img-responsive\" />\n<h2>"
    + alias2(helpers.gettext.call(alias1,"Darn it!",{"name":"gettext","hash":{},"data":data}))
    + "</h2>\n<div class=\"text-small\">\n"
    + alias2(helpers.gettext.call(alias1,"Something went wrong while trying to load this feed. Try again in a little while.",{"name":"gettext","hash":{},"data":data}))
    + "\n</div>\n<div class=\"text-small\">\n"
    + alias2(helpers.gettext.call(alias1,"Please visit %(discussDisqus)s to learn more.",{"name":"gettext","hash":{"discussDisqus":helpers.tag.call(alias1,"a",{"name":"tag","hash":{"text":"Discuss Disqus","href":"//disqus.com/home/discussion/channel-discussdisqus/issues_loading_your_feed_send_us_more_details/"},"data":data})},"data":data}))
    + "\n</div>\n</div>\n";
},"useData":true})

});
